import { render, staticRenderFns } from "./DetailsCycleDetails.vue?vue&type=template&id=0987868d&scoped=true&"
import script from "./DetailsCycleDetails.vue?vue&type=script&lang=js&"
export * from "./DetailsCycleDetails.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCycleDetails.vue?vue&type=style&index=0&id=0987868d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987868d",
  null
  
)

export default component.exports